//
//
//
//
//
//

// 加载所需icon文件
const _require = require.context('./', true, /\.svg$/);
_require.keys().forEach(key => _require(key));
export default {
  name: 'icon',
  props: [
    'symbol',
    'className'
  ],
  computed: {
    iconClass() {
      const {symbol, className} = this;
      return className ? `Icon Icon-${symbol} ${className}` : `Icon Icon-${symbol}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/icons/index.vue